import React from 'react';

import {Helmet} from 'views/module';

import NewClientScene from 'views/scenes/client/new/NewClient';

const ClientNew = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <NewClientScene
      />
    </>
  );
};

export default ClientNew;
